// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"style_itemsContainer__FLZ03","items":"style_items__xlQjH","title":"style_title__dRYRy","texte":"style_texte__RqYjB"};